// 加载所有的指令
import './directives';

// 加载所有的过滤器
import './filters';

// 加载所有的纯 JS 方法
import Tools from './tools';

export default Tools;



// WEBPACK FOOTER //
// ./src/utils/index.js